<template>
  <div class="p-3 w-full bg-gray-50 text-gray-700 shadow">
    <div class="w-full font-semibold mb-2">
      {{ name }}
    </div>
    <div class="flex items-center justify-start mb-1">
      <div class="text-2xs font-bold p-1 bg-red-200 text-red-700 rounded">
        {{ calculatedDiscount }}
      </div>
      <div class="ml-1 text-2xs text-gray-500 line-through">
        {{ $rupiah(fullPrice) }}
      </div>
    </div>
    <div class="font-bold mb-2 text-sm text-orange-600">
      {{ $rupiah(price) }}
    </div>
    <p
      class="leading-tight"
      v-html="description" />
    <div class="flex items-center justify-end mt-4">
      <button
        :disabled="$store.state.loading"
        class="flex-none rounded-lg p-3 bg-orange-600 text-white font-bold text-sm focus:outline-none active:bg-orange-500 disabled:cursor-not-allowed disabled:opacity-75"
        @click="buy()">
        Beli Tiket
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      validator: (val) => true,
      default: null,
    },
    name: {
      validator: (val) => true,
      default: null,
    },
    description: {
      validator: (val) => true,
      default: null,
    },
    price: {
      validator: (val) => true,
      default: null,
    },
    fullPrice: {
      validator: (val) => true,
      default: null,
    },
    calculatedDiscount: {
      validator: (val) => true,
      default: null,
    },
  },
  mounted() {

  },
  methods: {
    async addToCart() {
      try {
        await this.$store.dispatch('addToCart', this.id);
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.commit('setPendingAction', {
            type: 'addToCart',
            payload: this.id,
          });
          this.$store.commit('shouldAuth', true);
        } else {
          throw error;
        }
      }
    },
    async buy() {
      this.$store.commit('setLoading', true);
      try {
        await this.addToCart();
        if (! this.$store.state.shouldAuth) {
          window.location.href = '/cart';
        }
      } catch (error) {
        this.$store.commit('setLoading', false);
        throw error;
      }
      this.$store.commit('setLoading', false);
    },
  }
}
</script>
